import Axios from '../config/Axios';

export default function masterList(page = 1, perPage = 50, orderBy = 'cUserName', order = 'ASC', bActiveDocs = true, cSearch) {
  // O backend atual filtra a Lista Mestra pelo status textual da versao.
  const cStatus = bActiveDocs ? 'published' : 'archived';

  return Axios.get('/report/master-list', {
    params: {
      page,
      perPage,
      orderBy,
      order,
      bActiveDocs,
      cStatus,
      cSearch
    }
  }).then(oResponse => oResponse.data);
}

export function masterListPdf(cSearch, orderBy = 'cUserName', order = 'ASC') {
  return Axios.get('/report/master-list-pdf', {
    params: {
      cSearch,
      orderBy,
      order
    },
    responseType: 'blob'
  }).then(oResponse => oResponse.data);
}

export function masterListXlsx(cSearch, orderBy = 'cUserName', order = 'ASC') {
  return Axios.get('/report/master-list-xlsx', {
    params: {
      cSearch,
      orderBy,
      order
    },
    responseType: 'blob'
  }).then(oResponse => oResponse.data);
}
